import React from "react";
import Lottie from "lottie-react";
import groovyWalkAnimation from "./planets.json";

const PlanetLottie = () => <Lottie className=" w-[22rem] sm:!w-[31rem]" animationData={groovyWalkAnimation}

loop={true} />;

export default PlanetLottie;